import React from 'react';
import './ErrorBanner.css';

const ErrorBanner = ({ message, onRetry }) => (
  <div className="error-banner" role="alert">
    <span className="error-banner__text">{message}</span>
    {onRetry && (
      <button className="error-banner__retry" onClick={onRetry}>
        Réessayer
      </button>
    )}
  </div>
);

export default ErrorBanner;
